<template>
  <div class="error401">
    <div class="container">
      <div class="row">
        <div class="col-sm-4 col-sm-offset-2 text-center">
          <h1 class="error401__heading"><span class="error401__title">401</span><br/>
          <span class="error401__lead">คุณไม่ได้รับอนุญาต<br class="newline-sm"/>ให้เข้าหน้านี้ค่ะ</span><br/>
          <span class="error401__text">ลองเข้าทางอื่นนะคะ</span></h1>
        </div>
        <div class="col-sm-4 text-center">
          <img class="" src="../assets/img/error-image.png" :alt="$config.WEBSITE_NAME + ' Error 401 Page'"
            :srcset="`${img1} 1x, ${img2} 2x`" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-sm-offset-4">
          <a class="btn btn--white" href="/">กลับไปหน้าแรก</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img1 from '../assets/img/error-image.png'
import img2 from '../assets/img/error-image@2x.png'
export default {
  name: 'Error401',
  data () {
    return {
      img1: img1,
      img2: img2
    }
  }
}
</script>

<style scoped lang="scss">
  .error401 {
    padding: 40px 0;

    &__heading {
      margin: 0px 0 50px;

      @media (min-width: 768px) {
        margin: 70px 0 50px;
      }
    }
    &__title {
      font-size: 40px;
      color: #CB92C2;

      @media (min-width: 768px) {
        font-size: 100px;
      }
    }
    &__lead {
      font-size: 20px;

      @media (min-width: 768px) {
        font-size: 26px;
      }
    }
    &__text {
      font-size: 16px;
      font-weight: lighter;

      @media (min-width: 768px) {
        font-size: 22px;
      }
    }
  }

  .newline-sm {
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// 401.vue?66320f2d